import { UnitType } from '../generated/graphql';

export interface UnitTypeOptions {
    id: UnitType;
    name: UnitType;
}

type UnitTypeCategory = 'liquid' | 'mass' | 'pieces';

const unitTypeMap: Record<UnitType, UnitTypeCategory> = {
    [UnitType.Ml]: 'liquid',
    [UnitType.Liter]: 'liquid',
    [UnitType.Kg]: 'mass',
    [UnitType.G]: 'mass',
    [UnitType.Pcs]: 'pieces',
};

const unitTypeMapByType: Record<UnitTypeCategory, Array<UnitType>> = {
    'liquid': [UnitType.Liter, UnitType.Ml],
    'mass': [UnitType.Kg, UnitType.G],
    'pieces': [UnitType.Pcs],
};

export const getSimillarUnitTypes = (unitTypes: Array<UnitType>) => {
    return unitTypes.reduce((acc: Array<UnitType>, currentUnitType) => {
        const unitTypeCategory = unitTypeMap[currentUnitType];
        const simillarUnitTypes = unitTypeMapByType[unitTypeCategory];
        const result = [...acc, ...simillarUnitTypes];

        return result;
    }, []);
};

export const setUnitTypes = ( array: Array<UnitTypeOptions>, storageUnitType?: UnitType, conversionUnitType?: UnitType | null) => {
    if (storageUnitType) {
        const simillarUnits = getSimillarUnitTypes([storageUnitType]);
        simillarUnits.forEach(similarUnit => {
            array.push({ id: similarUnit, name: similarUnit });
        });
    }

    if (conversionUnitType) {
        const simillarUnits = getSimillarUnitTypes([conversionUnitType]);
        simillarUnits.forEach(similarUnit => {
            array.push({ id: similarUnit, name: similarUnit });
        });
    }
};